<template>
  <div class="flex overflow-hidden">
    <div class="w-[351px] h-screen border-r-2 border-gray-300/30 flex flex-col gap-y-2">
      <div class="flex items-center gap-4 mx-4 my-2">
        <button>
          <img class="w-3.5" src="../../assets/images/arrow-back-blue.svg" @click="onBack" />
        </button>
        <span class="font-semibold grow">Settings</span>
      </div>
      <div class="px-3">
        <div v-for="(item, index) in menuItems" :key="index">
          <div>
            <span class="text-xs text-slate-400">
              {{ item.name }}
            </span>
            <div
              v-for="(child, index) in item.children"
              :key="index"
              @click="onItemClicked(child)"
              class="flex items-center h-8 transition duration-500 ease-out transform rounded-md cursor-pointer group"
              :class="[
                child.route == route.name ? 'bg-theme-100' : '',
                username != Users.Admin && child.name == 'Installation'
                  ? 'text-gray-400 cursor-default'
                  : 'hover:bg-theme-100',
              ]">
              <Icon
                :icon="'menu:md:arrow-right'"
                class="mt-1 ease-in-out delay-700 transform text-theme-400"
                :class="[
                  child.route == route.name ? 'block' : 'hidden',
                  username != Users.Admin && child.name == 'Installation'
                    ? 'hidden'
                    : 'group-hover:block ml-3',
                ]" />
              <span
                class="text-xs"
                :class="[
                  child.route == route.name ? 'ml-1' : 'ml-3',
                  username != Users.Admin && child.name == 'Installation'
                    ? '='
                    : 'group-hover:ml-1',
                ]">
                {{ child.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="flex-col w-full h-screen 3xl:container">
      <div class="flex flex-col h-full">
        <div class="flex-1 h-full">
          <div class="flex flex-col h-full">
            <slot name="content"></slot>
          </div>
        </div>
        <div class="flex justify-end gap-4 mb-2 mr-4 text-xs">
          <a
            href="https://www.infosupport.gr/el/"
            target="_blank"
            class="text-theme-600 hover:text-theme-900"
            >Infosupport S.A.</a
          >
          <a href="" target="_blank" class="text-theme-600 hover:text-theme-900">Get Help</a>
          <span class="text-gray-500">&copy; 2024 | Infosupport S.A. | All Rights Reserved</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth';
import { Icon } from '@iconify/vue';
import { storeToRefs } from 'pinia';
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useModulesStore } from '@/stores/modules';
import type { ModuleInstallation } from '@/types/MW';
import { Users, LocalStorageKeys } from '@/utils/constants';

const { CONFIGURATION, USERSETUP } = useModulesStore();

const router = useRouter();
const route = useRoute();
const previousRoute = ref<string>('/dashboard');

const { username } = storeToRefs(useAuthStore());

onMounted(() => {
  generateMenu();
  const lastRoute = router.options.history.state.back?.toString();
  if (lastRoute && !lastRoute.includes('/settings/')) previousRoute.value = lastRoute;
});

function generateMenu() {
  let installationModules: ModuleInstallation[] = [];
  const storedInstallation = localStorage.getItem(LocalStorageKeys.InstallationModules);
  if (storedInstallation)
    installationModules = JSON.parse(storedInstallation) as ModuleInstallation[];

  if (installationModules.find((m) => m.moduleName === USERSETUP))
    menuItems.value.push({
      name: 'USER SETUP',
      tag: USERSETUP,
      children: [
        {
          name: 'Users',
          route: 'user-management',
        },
        {
          name: 'Roles',
          route: 'roles-management',
        },
      ],
    });
  if (installationModules.find((m) => m.moduleName === CONFIGURATION))
    menuItems.value.push({
      name: 'CONFIGURATION',
      tag: CONFIGURATION,
      children: [
        {
          name: 'Initial data',
        },
        {
          name: 'App preferences',
          route: 'app-preferences',
        },
        {
          name: 'Installation',
          route: 'settings-installation',
        },
        {
          name: 'Permissions',
        },
        {
          name: 'Reports',
        },
        {
          name: 'General setup',
        },
      ],
    });
}

type MenuItem = {
  name: string;
  tag?: string;
  children?: MenuItem[] | null;
  route?: string;
};

const menuItems = ref<MenuItem[]>([
  {
    name: 'INFORMATION',
    children: [
      {
        name: 'My account',
        route: 'my-account',
      },
      {
        name: 'About the app',
      },
    ],
  },
]);
function onBack() {
  previousRoute.value ? router.push(previousRoute.value) : router.push('/dashboard');
}

function onItemClicked(child: MenuItem) {
  if (child.name == 'Installation' && username.value !== Users.Admin) return;
  router.push({ name: child.route });
}
</script>
